/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-26 10:01:09
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-10-25 17:03:47
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  // 菜单列表
  getList: params => request({
    url: `${requestUrl}/menus`,
    method: "get",
    params
  }),

  // 新增菜单
  addMenu: data => request({
    url: `${requestUrl}/menu`,
    method: "post",
    data
  }),

  // 修改菜单
  editMenu: data => request({
    url: `${requestUrl}/menu`,
    method: "put",
    data
  }),

  // 通过id删除菜单
  deleteMenuById: id => request({
    url: `${requestUrl}/menu/${id}`,
    method: "delete"
  }),

  // 通过角色id获取菜单
  getMenuByRoleId: params => request({
    url: `${requestUrl}/current-user/menus?parseToTree=true&clientType=WEB&effect=true`,
    method: "get",
    params
  }),
  getItantentMenu: data => request({
    url: `${requestUrl}/menus/query-by-codes?parseToTree=true&clientType=WEB`,
    method: "post",
    data
  })
};

export default api;
